import Swiper from 'swiper'
import SwiperCore, { Navigation } from 'swiper/core'

SwiperCore.use([Navigation])

export default class ProductHalfVideoGridSlider {
  constructor(component) {
    this.dom = {
      $component: component,
      $sectionMobile: component.querySelector('.js-ProductHalfVideoGridSliderMobile'),
      $sectionDesktop: component.querySelector('.js-ProductHalfVideoGridSliderDesktop'),
    }
    this.state = {
      mobileLoaded: false,
      desktopLoaded: false,
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.loadProducts()
    window.addEventListener('resize', this.loadProducts.bind(this))
  }

  initSlider(container) {
    new Swiper(container, {
      slidesPerView: 1,
    })
  }

  loadProducts() {
    const { dom, state } = this

    if (state.desktopLoaded && state.mobileLoaded) {
      return
    }

    const mountCards = new Event('mountproductcards')
    let slides = false
    let container = false

    if (!state.desktopLoaded && window.innerWidth >= 1024) {
      slides = window.basis.ProductHalfVideoGridSlider.desktop
      container = dom.$sectionDesktop.querySelector('.js-productGridSliderContainer')
      state.desktopLoaded = true
    } else if (!state.mobileLoaded) {
      slides = window.basis.ProductHalfVideoGridSlider.mobile
      container = dom.$sectionMobile.querySelector('.js-productGridSliderContainer')
      state.mobileLoaded = true
    }

    container.querySelector('.swiper-wrapper').innerHTML = slides
    this.initSlider(container)
    document.dispatchEvent(mountCards)
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductHalfVideoGridSlider = this
  }
}
